// extracted by mini-css-extract-plugin
export default {"context-menu__message":"_5DD5DeJi","context-menu__message__secondary":"_5D1jbcWx","context-menu__message__primary":"_5D3SSvgp"};